export default "__VITE_ASSET__ZfXYB58m__"